import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useRadioProps } from './RadioGroupContext';
import { cn } from 'Utils/cn';

const Radio = forwardRef(function Radio(props, ref) {
    const { children, id, className, disabled, ...inputProps } = useRadioProps(props);

    return (
        <label
            className={cn('inline-flex items-center select-none gap-2', !disabled && 'cursor-pointer', className)}
            htmlFor={id}
        >
            <div className="inline-flex shrink-0 size-5 relative">
                <input
                    ref={ref}
                    type="radio"
                    id={id}
                    className={cn(
                        'peer bg-white appearance-none size-full border-1 border-gray-300 rounded-full shadow-sm transition-all cursor-pointer text-dark-blue',
                        'focus-visible:outline-none focus-visible:ring-2 ring-primary/20 focus-visible:border-primary',
                        'disabled:bg-gray-100 disabled:border-gray-200 disabled:cursor-not-allowed',
                    )}
                    disabled={disabled}
                    {...inputProps}
                />

                <span className="pointer-events-none absolute top-1/2 left-1/2 -translate-1/2 size-3 rounded-full peer-checked:bg-dark-blue peer-checked:scale-100 scale-0 transition-transform peer-disabled:bg-gray-600" />
            </div>

            <span className="grow text-sm">{children}</span>
        </label>
    );
});

export default Radio;

Radio.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    disabled: PropTypes.bool,
};
